import { fromJS, List, Record } from 'immutable';
import { CompanyAccount } from './company-account.model';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';

const SCHEMA = Object.freeze({
  ACCESS_TOKEN: '',
  ACCOUNTS: List<CompanyAccount>([]),
  EXPIRES_IN: 0,
  REFRESH_TOKEN: '',
  SCOPE: '',
  TOKEN_TYPE: '',
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class UserAccount extends Record(RECORD) {
  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});
    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.ACCOUNTS,
        value: props.get(KEYS.ACCOUNTS)
          ? this.accounts.map((params) => new CompanyAccount(params))
          : List<CompanyAccount>([]),
      },
    ]);

    return selfModel as UserAccount;
  }

  get accessToken(): string {
    return this.get(KEYS.ACCESS_TOKEN);
  }

  get accounts(): List<CompanyAccount> {
    return this.get(KEYS.ACCOUNTS);
  }

  get expiresIn(): number {
    return this.get(KEYS.EXPIRES_IN);
  }

  get refreshToken(): string {
    return this.get(KEYS.REFRESH_TOKEN);
  }

  get scope(): string {
    return this.get(KEYS.SCOPE);
  }

  get tokenType(): string {
    return this.get(KEYS.TOKEN_TYPE);
  }

  get hasMultipleAccounts(): boolean {
    return this.get(KEYS.ACCOUNTS).size > 1;
  }

  /**
   * Parse user id from JWT token
   */
  userId(): string {
    const parts = this.accessToken.split('.');
    try {
      const decodedToken = JSON.parse(atob(parts[1]));
      return decodedToken.user_id;
    } catch (e) {
      return null;
    }
  }
}
